import { render } from "./TheEvent.vue?vue&type=template&id=95b569ea&scoped=true"
import script from "./TheEvent.vue?vue&type=script&lang=ts"
export * from "./TheEvent.vue?vue&type=script&lang=ts"

import "./TheEvent.vue?vue&type=style&index=0&id=95b569ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95b569ea"

export default script